import "./style.scss";
import MultiplierSvg from "@/src/svg/CustomUtils/MultiplierSvg";
import ApproveSvg from "@/src/svg/CustomUtils/ApproveSvg";
import CloseSvg from "@/src/svg/CustomUtils/CloseSvg";
import ArrowSvg from "@/src/svg/autoCompile/ArrowSvg";
import CalendarSvg from "@/src/svg/CustomUtils/CalendarSvg";
import { useRef, useState } from "react";

type Props = {
  title: string;
  onClose: () => void;
};

const getTodayDate = () => {
  const date = new Date();
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${year}-${month}-${day}`;
};

const CustomIncomeManagement = ({ title, onClose }: Props) => {
  const [selectedDate, setSelectedDate] = useState<string>(getTodayDate());
  const dateInputRef = useRef<HTMLInputElement | null>(null);
  const invoiceOptions = ["23059-I/01", "23059-I/02", "23059-I/03"];
  const accountOptions = ["IEU PKO", "IEU Consaltens", "Main account"];

  const handleOpenDatePicker = () => {
    if (!dateInputRef.current) return;

    if (typeof dateInputRef.current.showPicker === "function") {
      dateInputRef.current.showPicker();
    } else {
      dateInputRef.current.focus();
      dateInputRef.current.click();
    }
  };
  return (
    <div className="custom-income">
      <div className="custom-income-title">
        <div className="custom-income-title-text">
          <p>{title}</p>
        </div>
        <div className="custom-income-title-close" onClick={onClose}>
          <CloseSvg />
        </div>
      </div>
      <div className="custom-income-calc">
        <div className="custom-income-calc-date" onClick={handleOpenDatePicker}>
          <input ref={dateInputRef} type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} />
          <CalendarSvg />
        </div>
        <div className="custom-income-calc-value">
          <div className="custom-income-calc-value-input">
            <input type="text" placeholder="0.00" />
          </div>
          <div className="custom-income-calc-value-select">
            <select>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="UAH">UAH</option>
            </select>
            <ArrowSvg />
          </div>
        </div>
        <div className="custom-income-calc-multiplier">
          <input type="text" placeholder="x0.00" />
          <div className="custom-income-calc-multiplier-line"></div>
          <MultiplierSvg />
        </div>
        <div className="custom-income-calc-result">
          <div className="custom-income-calc-result-title">
            <p>Result:</p>
          </div>
          <div className="custom-income-calc-result-input">
            <input type="text" placeholder="0.00" />
            <p>USD</p>
          </div>
        </div>
      </div>
      <div className="custom-income-selectors">
        <div className="custom-income-selectors-item">
          <div className="custom-income-selectors-item-label">
            <p>Invoice No</p>
          </div>
          <div className="custom-income-selectors-item-select">
            <select>
              <option value="">Please Choose Invoice</option>
              {invoiceOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <ArrowSvg />
          </div>
        </div>
        <div className="custom-income-selectors-item">
          <div className="custom-income-selectors-item-label">
            <p>To Account:</p>
          </div>
          <div className="custom-income-selectors-item-select">
            <select>
              <option value="">Please Choose</option>
              {accountOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
            <ArrowSvg />
          </div>
        </div>
      </div>
      <div className="custom-income-note">
        <textarea placeholder="Note..." />
      </div>
      <div className="custom-income-history">
        <div className="custom-income-history-header">
          <div className="custom-income-history-header-label">
            <p>History</p>
          </div>
          <div className="custom-income-history-header-icons">
            <div className="custom-income-history-header-icons-approve">
              <ApproveSvg />
            </div>
            <div className="custom-income-history-header-icons-close">
              <CloseSvg />
            </div>
            <div className="custom-income-history-header-icons-arrow">
              <ArrowSvg />
            </div>
          </div>
        </div>
        <div className="custom-income-history-list">
          <div className="custom-income-history-list-item">
            <div className="custom-income-history-list-item-main">
              <div className="custom-income-history-list-item-main-date">
                <p>17.05.2025</p>
              </div>
              <div className="custom-income-history-list-item-main-invoice">
                <p>23059-I/01</p>
              </div>
              <div className="custom-income-history-list-item-main-value">
                <p>1 400.00 EUR</p>
              </div>
            </div>
            <div className="custom-income-history-list-item-multiplier">
              <p>x0.98</p>
            </div>
            <div className="custom-income-history-list-item-result">
              <div className="custom-income-history-list-item-result-label">
                <p>IEU PKO</p>
              </div>
              <div className="custom-income-history-list-item-result-value">
                <p>1 480.00 USD</p>
              </div>
            </div>
          </div>
          <div className="custom-income-history-list-item">
            <div className="custom-income-history-list-item-main">
              <div className="custom-income-history-list-item-main-date">
                <p>11.02.2025</p>
              </div>
              <div className="custom-income-history-list-item-main-invoice">
                <p>23059-I/02</p>
              </div>
              <div className="custom-income-history-list-item-main-value">
                <p>1 100.00 EUR</p>
              </div>
            </div>
            <div className="custom-income-history-list-item-multiplier">
              <p>x0.97</p>
            </div>
            <div className="custom-income-history-list-item-result">
              <div className="custom-income-history-list-item-result-label">
                <p>IEU PKO</p>
              </div>
              <div className="custom-income-history-list-item-result-value">
                <p>1 180.00 USD</p>
              </div>
            </div>
          </div>
          <div className="custom-income-history-list-item">
            <div className="custom-income-history-list-item-main">
              <div className="custom-income-history-list-item-main-date">
                <p>07.01.2025</p>
              </div>
              <div className="custom-income-history-list-item-main-invoice">
                <p>23059-I/03</p>
              </div>
              <div className="custom-income-history-list-item-main-value">
                <p>400.00 EUR</p>
              </div>
            </div>
            <div className="custom-income-history-list-item-multiplier">
              <p>x0.96</p>
            </div>
            <div className="custom-income-history-list-item-result">
              <div className="custom-income-history-list-item-result-label">
                <p>IEU Consaltens </p>
              </div>
              <div className="custom-income-history-list-item-result-value">
                <p>420.00 USD</p>
              </div>
            </div>
          </div>
        </div>
        <div className="custom-income-history-total">
          <p>Total</p>
          <p>3 080.00 USD</p>
        </div>
      </div>
    </div>
  );
};

export default CustomIncomeManagement;
